const actions = {
    GET_VALES_REQUEST:         'GET_VALES_REQUEST',
    GET_VALES_SUCCESS:         'GET_VALES_SUCCESS',
    GET_VALE_REQUEST:          'GET_VALE_REQUEST',
    GET_VALE_SUCCESS:          'GET_VALE_SUCCESS',
    UPDATE_ESTADO_VALE_REQUEST:'UPDATE_ESTADO_VALE_REQUEST',
    UPDATE_ESTADO_VALE_SUCCESS:'UPDATE_ESTADO_VALE_SUCCESS',
    SET_LOADING:               'VALES_CONSUMO_SET_LOADING',

    getVales:       (query)        => ({ type: actions.GET_VALES_REQUEST, query }),
    getVale:        (id)           => ({ type: actions.GET_VALE_REQUEST, id }),
    updateEstado:   (id, estado)   => ({ type: actions.UPDATE_ESTADO_VALE_REQUEST, id, payload: { estado } }),
};

export default actions;
